module.exports = __webpack_public_path__ + "files/rodriguez.05994c65ddb631f9d62f66c16dfc7b54.pdf";